'use client';

import { cn } from '@/lib/utils';
import IconPaginationLeft from '@/svg/icon_pagination_left.svg';
import IconPaginationRight from '@/svg/icon_pagination_right.svg';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
  maxVisiblePages?: number; // 한 번에 보여줄 페이지 개수
}

export default function Pagination({
  page,
  totalPages,
  onPageChange,
  className,
  maxVisiblePages = 5,
}: PaginationProps) {
  const onClickBtn = (newPage: number) => {
    onPageChange(newPage);
    window.scrollTo({ top: 0 });
  };

  // === 핵심 로직 ===
  const currentBlock = Math.floor((page - 1) / maxVisiblePages); // 현재 블록 인덱스 (0부터 시작)
  const startPage = currentBlock * maxVisiblePages + 1;
  const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // 블록 단위 이동 계산
  const prevBlockLastPage = startPage - 1;
  const nextBlockFirstPage = endPage + 1;

  return (
    <div
      className={cn(
        'desktop:pt-20 flex items-center justify-center gap-2 pt-10',
        className,
      )}
    >
      {/* 이전 버튼: 이전 블록으로 이동 */}
      <button
        className="cursor-pointer px-2 py-1 disabled:cursor-default"
        onClick={() => onClickBtn(prevBlockLastPage)}
        disabled={page <= maxVisiblePages}
      >
        <IconPaginationLeft
          width={40}
          height={40}
          className={cn(
            page <= maxVisiblePages ? 'stroke-font-grayblue' : 'stroke-level-2',
          )}
        />
      </button>

      {/* 첫 페이지로 가는 버튼 */}
      {/* {startPage > 1 && (
        <>
          <button
            className="typo-18 hover:bg-bg-graylight text-font-grayblue flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white"
            onClick={() => onClickBtn(1)}
          >
            1
          </button>
          {startPage > 2 && <span className="text-font-grayblue">...</span>}
        </>
      )} */}

      {/* 페이지 번호들 */}
      {pageNumbers.map((num) => (
        <button
          key={num}
          className={cn(
            'typo-18 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full font-bold',
            page === num
              ? 'bg-level-2 text-main-yellow'
              : 'hover:bg-bg-graylight text-font-grayblue bg-white',
          )}
          onClick={() => onClickBtn(num)}
        >
          {num}
        </button>
      ))}

      {/* 마지막 페이지로 가는 버튼 */}
      {/* {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <span className="text-font-grayblue">...</span>
          )}
          <button
            className="typo-18 hover:bg-bg-graylight text-font-grayblue flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white"
            onClick={() => onClickBtn(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )} */}

      {/* 다음 버튼 */}
      <button
        className="cursor-pointer px-2 py-1 disabled:cursor-default"
        onClick={() => onClickBtn(nextBlockFirstPage)}
        disabled={endPage >= totalPages}
      >
        <IconPaginationRight
          width={40}
          height={40}
          className={cn(
            endPage >= totalPages ? 'stroke-font-grayblue' : 'stroke-level-2',
          )}
        />
      </button>
    </div>
  );
}

// interface PaginationProps {
//   page: number;
//   totalPages: number;
//   onPageChange: (page: number) => void;
//   className?: string;
// }
// export default function Pagination({
//   page,
//   totalPages,
//   onPageChange,
//   className,
// }: PaginationProps) {
//   const onClickBtn = (page: number) => {
//     onPageChange(page);
//     window.scrollTo({
//       top: 0,
//     });
//   };
//   return (
//     <div
//       className={`desktop:pt-20 flex items-center justify-center gap-2 pt-10 ${className || ''}`}
//     >
//       <button
//         className="cursor-pointer px-2 py-1 disabled:cursor-default"
//         onClick={() => onClickBtn(page - 1)}
//         disabled={page === 1}
//       >
//         <IconPaginationLeft
//           width={40}
//           height={40}
//           className={cn(page === 1 ? 'stroke-font-grayblue' : 'stroke-level-2')}
//         />
//       </button>
//       {[...Array(totalPages)].map((_, idx) => (
//         <button
//           key={idx}
//           className={`typo-18 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full font-bold disabled:cursor-default ${
//             page === idx + 1
//               ? 'bg-level-2 text-main-yellow'
//               : 'hover:bg-bg-graylight text-font-grayblue bg-white'
//           }`}
//           onClick={() => onClickBtn(idx + 1)}
//         >
//           {idx + 1}
//         </button>
//       ))}
//       <button
//         className="cursor-pointer px-2 py-1 disabled:cursor-default"
//         onClick={() => onClickBtn(page + 1)}
//         disabled={page === totalPages}
//       >
//         <IconPaginationRight
//           width={40}
//           height={40}
//           className={cn(
//             page === totalPages ? 'stroke-font-grayblue' : 'stroke-level-2',
//           )}
//         />
//       </button>
//     </div>
//   );
// }
